import PostShareButton from "./post-share-button";

export default PostShareButton;